/* @ngInject */

export default (FeeAndChargeType) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function FeeAndCharge(id, feeAndChargeType, name, amount, feePayable) {
    this.id = id;
    this.feeAndChargeType = feeAndChargeType;
    this.name = name;
    this.amount = amount;
    this.feePayable = feePayable;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  FeeAndCharge.Blank = function (feeAndChargeType, amount) {
    return FeeAndCharge.Build({
      id: _.uuid(),
      feeAndChargeType: FeeAndChargeType.Build(feeAndChargeType),
      name: '',
      amount,
      feePayable: ''
    });
  };
  FeeAndCharge.Build = function (data) {
    return new FeeAndCharge(
      data.id ? data.id : _.uuid(),
      data.feeAndChargeType,
      data.name ? data.name : '',
      data.amount ? data.amount : 0,
      data.feePayable ? data.feePayable : ''
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  FeeAndCharge.prototype.getName = function () {
    return this.name;
  };
  FeeAndCharge.prototype.getTypeName = function () {
    return this.feeAndChargeType.name;
  };

  return FeeAndCharge;
};
